export const GET_ADMIN_LIST = "GET_ADMIN_LIST";
export const ADMIN_PROCESSING = "ADMIN_PROCESSING";
export const STOP_ADMIN_PROCESSING = "STOP_ADMIN_PROCESSING";
